import logo from './logo.svg';
import './App.css';
import Routes from './routes/routes';
import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from './stores/index';
import { AuthProvider } from './Authentication/AuthProvider';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';

function App() {
  return (
    <>
      {/* <Provider store={store}> */}
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <AuthProvider>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </AuthProvider>
      </MuiPickersUtilsProvider>
      {/* </Provider> */}
    </>
  );
}

export default App;
